import { Divider, Grid, Typography } from '@mui/material';
import React, { useContext } from 'react'
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import GlobalButton from '../../utility/globalButton/button';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { isAdmin } from '../../../utils/constants';

interface ShowErrorPopupProps {
    flagChangesNotSaveInBE: boolean, 
    errorMessageWhenChangesNotSave: string,
}

const ShowErrorPopup: React.FC<ShowErrorPopupProps> = (props) => {

    const { flagChangesNotSaveInBE, errorMessageWhenChangesNotSave } = props;
    const { userDetail } = useContext(UserContext) as UserContextPayload

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}>Something went wrong</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />  


                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container className={style.popupBodyGridContainer} gap={1}>
                                
                                {isAdmin(userDetail) && 
                                    <Grid item xs={12}>
                                        <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                            Admin Note: {errorMessageWhenChangesNotSave}
                                        </Typography>
                                    </Grid>
                                }

                                <Grid item xs={12}>
                                    <Typography className={`${globalStyles.primaryFontSize} ${globalStyles.secondaryFontWeight}`}>
                                        {flagChangesNotSaveInBE ? 
                                            `Something went wrong on our side. Please refresh and try again.` 
                                            : 
                                            `We're sorry, but your recent changes couldn't be saved. Please refresh and try again.`
                                        }
                                    </Typography>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container justifyContent={"center"} sx={{marginTop: "20px"}}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Refresh"
                                                className='primaryButtonStyle'
                                                sx={{width: "130px"}}
                                                onClick={() => window.location.reload()}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>                
        </>
    )
}

export default ShowErrorPopup
